import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {urlJoin} from '../../../utils/urlJoin';
import {environment} from '../../../../environments/environment';


@Injectable()
export class EtatService {
    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }


    loadcardAcheteur(data) {
        const resource = urlJoin(EtatService.base, 'umInst', 'searchCriteria');
        return this.http.post(resource, data);

    }

    loadDetailEtatAcheteur(data) {
        const resource = urlJoin(EtatService.base, 'vUmRcvInstDet', 'data');
        return this.http.post(resource, data);

    }

    AnnulEtatAcheteur(id) {
        const resource = urlJoin(EtatService.base, 'inscription/acheteur/updateExcStat', id);
        return this.http.post(resource, null);

    }

    loadFirstCardF(data) {
        const resource = urlJoin(EtatService.base, 'vUmSupplierEdocInfo', 'data');
        return this.http.post(resource, data);

    }


}
